import React from "react";
import {
  displayTransferRecipient,
  displayTransferStatus,
} from "../../utils/utils";
import { ReactComponent as Download } from "../../assets/ico_download.svg";

const IncomingTransfer = ({ incoming, handleLinkClick }) => {
  const isRequestForPay = incoming.originated_as_rfp === true;
  // Incoming RfP = the viewer is the REQUESTEE. Money flowed AWAY from them
  // when they paid — show "-$X" so it reads like a debit, no green treatment.
  // Once it's a money movement (Succeeded/Failed) we know money moved; for
  // anything earlier the row wouldn't be in history at all.
  const isRfpDebit = isRequestForPay && incoming.status === "SUCCEEDED";
  const amountClassName =
    isRequestForPay ? "amount" : "amount color_sending_success_color";
  const amountPrefix = isRfpDebit ? "-" : isRequestForPay ? "" : "+";
  const partyLabel = isRequestForPay
    ? incoming.sender_identifier || incoming.sender_name || "Someone"
    : displayTransferRecipient(incoming.recipient, true, incoming);

  return (
    <li
      style={{ cursor: "pointer" }}
      onClick={(event) => handleLinkClick(event)}
    >
      <div style={{ display: "flex" }}>
        <div className="history_icon bg_sending_bg_secondary">
          <Download className="fill_sending_bg_secondary stroke_sending_bg_primary" />
        </div>
        <div>
          <div style={{ fontSize: "12px", fontWeight: 550 }}>{partyLabel}</div>
          <div style={{ fontSize: "10px", marginTop: "3px" }}>
            {displayTransferStatus(incoming)}
          </div>
        </div>
      </div>

      <div className={amountClassName}>
        {amountPrefix}${incoming.amount.value}{" "}
      </div>
    </li>
  );
};

export default IncomingTransfer;
